import { InjectionToken, signal, Signal } from '@angular/core';

/** Personal data a flow can start its confirmation step with; not persisted, comes straight off the account. */
export interface IFlowDetailsPrefill {
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  /** Null when the account has no birthdate on record; the field stays empty. */
  birth_date: string | null;
}

const NO_PREFILL: Signal<IFlowDetailsPrefill | null> = signal(null);

/** Where the confirmation step looks for personal data to start from; see `libs/flows/onboarding/README.md`. */
export const FLOW_DETAILS_PREFILL = new InjectionToken<
  Signal<IFlowDetailsPrefill | null>
>('FLOW_DETAILS_PREFILL', {
  providedIn: 'root',
  factory: () => NO_PREFILL,
});
